import { render, staticRenderFns } from "./points.vue?vue&type=template&id=62c44034&scoped=true&"
import script from "./points.vue?vue&type=script&lang=js&"
export * from "./points.vue?vue&type=script&lang=js&"
import style0 from "./points.vue?vue&type=style&index=0&lang=less&"
import style1 from "./points.vue?vue&type=style&index=1&id=62c44034&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c44034",
  null
  
)

export default component.exports